import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { Container, Row, Col, Card, ListGroup } from "react-bootstrap";
import enterpriseImage1 from "../Assets/Image/enterpriseImage2.avif";
import { BsCheckCircleFill, BsArrowRightCircleFill } from "react-icons/bs";
import { FaCogs, FaClock, FaLightbulb, FaTools } from "react-icons/fa";
import { Helmet } from "react-helmet";
import "aos/dist/aos.css";
import "../Assets/Css/about.css";
import busduct1 from "../Assets/Image/busduct1.jpg";
import busduct2 from "../Assets/Image/busduct2.jpg";
import busduct3 from "../Assets/Image/busduct3.jpg";
import busduct4 from "../Assets/Image/busduct4.jpg";
import busduct5 from "../Assets/Image/busduct5.jpg";
import busduct6 from "../Assets/Image/busduct6.jpg";
import flexibleImage from "../Assets/Image/flexible.jpg";
import busbarImage from "../Assets/Image/busbar3D.jpg";
import stampedBusbarImage from "../Assets/Image/stampedBusbar.jpg";
import plugInBoxImage from "../Assets/Image/plugInBox1.jpg";
import subAssemblyImage from "../Assets/Image/subAssembly.jpg";
import busbar3DImage from "../Assets/Image/subAssembly1.jpg";

const ExpertiseSection = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [selectedIndustry, setSelectedIndustry] = useState(null);

  const handleOpenModal = (industry) => {
    setSelectedIndustry(industry);
    setShowModal(true);
  };
  const [mainImage, setMainImage] = useState("");

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedIndustry(null);
  };

  const handleOpenExpertiseModal = (item) => {
    setSelectedData(item);
    setMainImage(item.image);
    setSelectedIndustry(null);
    setShowModal(true);
  };

  const [expandedIndex, setExpandedIndex] = useState(0);

  const handleToggle = (index) => {
    setExpandedIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const features = [
    {
      icon: <FaCogs size={40} className="text-primary mb-3" />,
      title: "Advanced Machinery",
      description:
        "We use state-of-the-art automated machines to ensure precision, speed, and high-volume output.",
    },
    {
      icon: <FaClock size={40} className="text-primary mb-3" />,
      title: "Timely Delivery",
      description:
        "We are committed to delivering your orders on time, every time, at your doorstep.",
    },
    {
      icon: <FaLightbulb size={40} className="text-primary mb-3" />,
      title: "Innovative Solutions",
      description:
        "Our team supports new product development and offers tailored solutions for your engineering needs.",
    },
    {
      icon: <FaTools size={40} className="text-primary mb-3" />,
      title: "Skilled Workforce",
      description:
        "Our highly experienced team ensures quality workmanship and reliable support at every stage.",
    },
  ];

  const deltaIndustriesDetails = [
    {
      title: "Switchgear Industry",
      short:
        "Reliable connectors and busbars for safe, efficient power distribution.",
      image: busduct1,
      description:
        "We supply precision-engineered connectors, busbars, and flexible assemblies to the switchgear industry, ensuring safe, reliable, and efficient power distribution. Our components are designed for high-current capacity and durable, maintenance-friendly operation.",
    },
    {
      title: "Transformer Industry",
      short:
        "High-quality copper components for efficient transformer connections.",
      image: busduct2,
      description:
        "Our high-conductivity copper and aluminum components are tailored for transformer manufacturing, enabling efficient electrical connections with minimal losses. We help transformer OEMs deliver robust, long-lasting products for demanding grid and industrial applications.",
    },

    {
      title: "Busduct Industry",
      image: busduct3,
      short: "Custom busbars and joints for secure, modular busduct systems.",
      description:
        "We provide custom busbar assemblies, flexible connectors, and precision-machined joints for busduct systems. Our solutions ensure low-resistance, secure, and safe connections across sections, supporting scalable, modular power distribution networks.",
    },

    {
      title: "Electric Vehicle",
      short: "Advanced connectors and busbars supporting electric mobility.",
      image: busduct4,
      description:
        "Supporting the electric mobility revolution with advanced copper connectors, busbars, and laminated flexibles. Our lightweight, high-conductivity solutions help EV manufacturers deliver reliable, efficient power management systems in vehicles and charging infrastructure.",
    },

    {
      title: "Locomotive Industries",
      short: "Durable, vibration-resistant assemblies for rail applications.",
      image: busduct5,
      description:
        "Supplying robust, vibration-resistant copper and aluminum connectors, assemblies, and busbars designed to withstand the harsh operating conditions of locomotive and rail applications, delivering reliable power transfer and reduced maintenance cycles.",
    },

    {
      title: " Other Electrical Industries",
      short:
        "Tailored copper and aluminum solutions for diverse electrical needs.",
      image: busduct6,
      description:
        "We serve a wide range of electrical industries with custom-engineered copper and aluminum components. Our flexible production capabilities and quality standards support OEMs and contractors with reliable solutions for diverse power systems and control equipment.",
    },
  ];

  const expertiseData = [
    {
      title: "LAMINATED COPPER/ALUMINIUM FLEXIBLE JUMPER TO POWER INDUSTRY",
      image: flexibleImage,
      thumbnails: [
        "/image/flexible.jpg",
        "/image/flexible.jpg",
        "/image/flexible.jpg",
      ],
      description:
        "We specialize in laminated flexible copper connectors used in switchgear, transformers, and electrical panels. Our flexibles are designed for thermal expansion, vibration damping, and high-current capacity. These are manufactured with or without surface coatings based on customer requirements.",
      features: [
        "Contact Area Resistance Welded laminated flexibles",
        "Bare and Tin-plated contact areas",
        "Silver plating as per customer requirement",
        "Fully Tin plated Copper flexible lamination",
        "Rivetted flexibles bend to shapes",
      ],
      applications: [
        "Power Control Panels",
        "Transformers & Busducts",
        "Switchboards and Isolators",
        "Battery Banks and Inverters",
      ],
    },
    {
      title: "COPPER AND ALUMINIUM BUSBARS TO POWER INDUSTRY",
      image: busbarImage,
      thumbnails: ["/image/busbar3D.jpg"],
      description:
        "We manufacture high-quality busbars using copper and aluminium materials. These busbars are fabricated with precision bending and surface finishing to suit control panel and industrial power distribution needs.",
      features: [
        "All Types of fabricated Busbars",
        "Copper/Aluminium materials",
        "Edge Bending and Multi-Bend options",
      ],
      applications: [
        "LT/HT Switchgear Panels",
        "Industrial Control Cabinets",
        "Distribution Panels",
      ],
    },
    {
      title: "Stamped Busbars to Power Industry",
      image: stampedBusbarImage,
      thumbnails: ["/image/stampedBusbar.jpg"],
      description:
        "Our stamped busbars are designed using high-precision press tools to ensure accurate shape and repeatability. Ideal for compact applications where space and shape optimization is essential.",
      features: [
        "Stamped Busbars from Press Tools",
        "Spreader Links for MCCBs",
        "Surface coated and Soft Forged busbars",
      ],
      applications: [
        "MCCB Connections",
        "Panel Terminations",
        "Compact Electrical Modules",
      ],
    },
    {
      title: "Plug-in Box Assembly to Busduct Industry",
      image: plugInBoxImage,
      thumbnails: ["/image/plugInBox1.jpg"],
      description:
        "We provide custom plug-in box assemblies for busduct systems. Enclosures are tailored for size, layout, and powder coating standards. Designed for safe and efficient tap-offs from busduct lines.",
      features: [
        "Design and Development of Plug-in Boxes",
        "Custom Enclosure Sizes",
        "Powder Coating and Safety Features",
      ],
      applications: [
        "Busduct Tap-Off Units",
        "LT Power Distribution",
        "Panel-to-Busduct Connections",
      ],
    },
    {
      title: "Sub Assemblies to Switchgear & BTS",
      image: subAssemblyImage,
      thumbnails: ["/image/busbar3D.jpg"],
      description:
        "We offer precision sub-assemblies for switchgear and BTS equipment. These include copper contacts, steel inserts, and integrated components for high-reliability electrical systems.",
      features: [
        "Sub Assembly Manufacturing",
        "Copper and Steel Integration",
        "Contact System Assemblies",
      ],
      applications: [
        "Switchgear Panels",
        "BTS (Base Transceiver Station)",
        "Control Relay Systems",
      ],
    },
    {
      title: "3D Bending busbars to Power Industry",
      image: busbar3DImage,
      thumbnails: ["/image/subAssembly1.jpg"],
      description:
        "3D busbars are twisted or edge-bent copper rods/flats designed to fit complex installations. These custom-shaped conductors offer optimal routing, reduced joints, and better heat management.",
      features: [
        "Twisted & Edge-Bending Capability",
        "Copper Rod or Flat Design",
        "Custom Shape for Compact Spaces",
      ],
      applications: [
        "UPS Systems",
        "Compact Panels",
        "Power Management Systems",
      ],
    },
  ];

  return (
    <>
      <Helmet>
        <title>About Us - Delta Engineering | Power Industry Solutions</title>
        <meta
          name="description"
          content="Learn about Delta Engineering's mission, values, expertise, and sister company. We provide high-quality busbars, connectors, and engineered power components."
        />
        <meta
          name="keywords"
          content="Delta Engineering, About Delta Engineering, Power Solutions, Busbars, Connectors, Electrical Components, Technocrat Busway, Electrical Manufacturing"
        />
        <meta name="robots" content="index, follow" />

        <meta property="og:title" content="About Delta Engineering" />
        <meta
          property="og:description"
          content="Discover how Delta Engineering is empowering the power industry with quality busbars, connectors, and flexible solutions."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.deltaengnsk.com/about" />
        <meta property="og:site_name" content="Delta Engineering" />

        <meta name="twitter:title" content="About Delta Engineering" />
        <meta
          name="twitter:description"
          content="Learn more about Delta Engineering and our mission to deliver precise, high-performance components to the power industry."
        />
      </Helmet>

      <div className="banner2-section d-flex align-items-center justify-content-center position-relative">
        <div className="banner2-overlay-layer"></div>

        <div className="banner2-overlay text-center position-relative z-2">
          <h2 className="banner2-title" data-aos="zoom-in" data-aos-delay="300">
            <span class="white-text">About</span>{" "}
            <span class="blue-text">US</span>
          </h2>

          <p
            className="banner2-subtitle"
            data-aos="zoom-in"
            data-aos-delay="200"
          >
            We provide high-quality copper connectors, busbars, and
            precision-engineered components.
          </p>
        </div>
      </div>

      <div className="py-3 pt-2">
        <Container>
          <Row
            className="text-center section-heading mb-5"
            data-aos="fade-down"
            data-aos-delay="100"
          >
            <Col>
              <h3 className="fw-bold section-title position-relative d-inline-block">
                About Us
                <span className="title-underline"></span>
              </h3>

              <p
                className="text-muted text-center mx-auto"
                style={{ maxWidth: 700 }}
              >
                Delta Engineering is a trusted name in the power industry,
                providing high-quality components and solutions. Our dedication
                to innovation and reliability ensures that we are always at the
                forefront of delivering the best to our clients.
              </p>
            </Col>
          </Row>
          <Row className="align-items-center my-5">
            <Col md={7} data-aos="zoom-in">
              <h2
                className="fw-bold mb-3 text-center text-md-start"
                style={{ color: "#0054fd" }}
              >
                Who We Are
              </h2>

              <p className="text-muted" style={{ textAlign: "justify" }}>
                At <strong>Delta Engineering</strong>, we focus on providing
                high-quality laminated copper flexible connectors and fabricated
                copper busbars to the power industry with the highest levels of
                customer satisfaction – we will do everything we can to meet
                your expectations.
              </p>
              <p className="text-muted" style={{ textAlign: "justify" }}>
                With dedicated manpower and state-of-the-art machines, we’re
                confident you’ll be happy working with us. Look around our
                manufacturing capacities and feel free to contact us.
              </p>
              <p className="text-muted" style={{ textAlign: "justify" }}>
                We align advanced manufacturing practices, skilled workforce,
                and modern technology to deliver high-performance components for
                the power industry — ensuring every solution meets the evolving
                needs of industrial clients.
              </p>
            </Col>
            <Col
              md={5}
              data-aos="zoom-in"
              className="d-flex justify-content-center align-items-center"
            >
              <img
                src={enterpriseImage1}
                alt="Enterprise Agility"
                className="aboutimg mb-3 img-fluid rounded"
                loading="lazy"
              />
            </Col>
          </Row>

          <section className="py-4 bg-light" id="why-us">
            <Container>
              <div className="text-center mb-4">
                <h3 className="fw-bold section-title position-relative d-inline-block">
                  Why Choose Us
                  <span className="title-underline"></span>
                </h3>
                <div>
                  <h4>Dedicated team with high experience.</h4>
                  <p className="why-choose-us mt-3">
                    State-of-the-art, high-end automated machines that produce
                    precise and consistent products. High-quality, low-cost
                    output for customer satisfaction. Committed delivery at your
                    doorstep. Happy to help with new product development.
                  </p>
                </div>
              </div>

              <Row className="g-4">
                {features.map((item, index) => (
                  <Col md={6} lg={3} key={index}>
                    <Card className="h-100 text-center shadow-sm border-0 p-3 why-us-card">
                      <Card.Body>
                        {item.icon}
                        <Card.Title
                          className="fw-semibold mt-2"
                          style={{ color: "#000" }}
                        >
                          {item.title}
                        </Card.Title>
                        <Card.Text
                          className="text-muted"
                          style={{ fontSize: "0.95rem" }}
                        >
                          {item.description}
                        </Card.Text>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Container>
          </section>
        </Container>
      </div>

      <section className="py-4 industries-delta-section">
        <Container>
          <Row className="justify-content-center mb-2">
            <h3
              className="fw-bold text-center section-title"
              data-aos="fade-down"
            >
              Industries We Serve
              <span className="title-underline"></span>
            </h3>
            <p className="text-muted text-center" style={{ maxWidth: 700 }}>
              Empowering power infrastructure with specialized components across
              industries.
            </p>
          </Row>

          <Row className="g-4">
            {deltaIndustriesDetails.map((industry, idx) => (
              <Col
                md={4}
                sm={6}
                xs={12}
                key={idx}
                data-aos="fade-up"
                data-aos-delay={idx * 100}
              >
                <Card
                  className="h-100 shadow-lg industry-card"
                  style={{ cursor: "pointer", transition: "transform 0.3s" }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "translateY(-5px)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "translateY(0)")
                  }
                >
                  <Card.Img
                    variant="top"
                    src={industry.image}
                    className="industry-img"
                  />
                  <Card.Body className="d-flex flex-column">
                    <Card.Title className="fw-bold">
                      {industry.title}
                    </Card.Title>
                    <Card.Text className="text-muted" style={{ flexGrow: 1 }}>
                      {industry.short}
                    </Card.Text>
                    <Button
                      variant="outline-primary"
                      className="mt-auto"
                      onClick={() => handleOpenModal(industry)}
                    >
                      Learn More
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>

        <Modal show={showModal} onHide={handleCloseModal} centered size="lg">
          <Modal.Header closeButton>
            <Modal.Title>{selectedIndustry?.title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <img
              src={selectedIndustry?.image}
              alt={selectedIndustry?.title}
              className="img-fluid mb-3 rounded"
              loading="lazy"
            />
            <p>{selectedIndustry?.description}</p>
          </Modal.Body>
        </Modal>
      </section>

      {/* <section className="expertise-section py-5 bg-light">
        <Container>
          <Row className="justify-content-center mb-4">
            <h3
              className="fw-bold text-center section-title"
              data-aos="fade-down"
            >
              Our Expertise in Power Industry
              <span className="title-underline"></span>
            </h3>
          </Row>

          <Row>
            <Col md={7}>
              <Row className="g-4">
                {expertiseData.map((item, index) => {
                  const isExpanded = expandedIndex === index;

                  return (
                    <Col key={index} xs={12}>
                      <Card
                        className={`shadow-sm rounded-4 card-hover w-100 ${
                          isExpanded ? "active-card" : ""
                        }`}
                      >
                        <Card.Img
                          variant="top"
                          src={item.image}
                          alt={item.title}
                          style={{ height: "250px", objectFit: "cover" }}
                        />
                        <Card.Body className="text-center">
                          <Card.Title
                            className="fw-bold text-uppercase mb-2"
                            style={{ color: "#003366" }}
                          >
                            {item.title}
                          </Card.Title>
                          <Button
                            variant={isExpanded ? "primary" : "outline-primary"}
                            size="sm"
                            onClick={() =>
                              setExpandedIndex(isExpanded ? null : index)
                            }
                          >
                            {isExpanded ? "Closed" : "View More"}
                          </Button>
                        </Card.Body>
                        <div className="d-md-none">
                          {isExpanded && (
                            <Card.Body className="pt-0">
                              <Card.Text className="text-muted small">
                                {item.description}
                              </Card.Text>

                              <h6 className="fw-bold mt-3">Features</h6>
                              <ListGroup variant="flush" className="mb-2">
                                {item.features.map((feature, i) => (
                                  <ListGroup.Item
                                    key={i}
                                    className="small d-flex align-items-center"
                                  >
                                    <BsCheckCircleFill className="text-success me-2" />
                                    {feature}
                                  </ListGroup.Item>
                                ))}
                              </ListGroup>

                              <h6 className="fw-bold mt-3">Applications</h6>
                              <ListGroup variant="flush">
                                {item.applications.map((app, i) => (
                                  <ListGroup.Item
                                    key={i}
                                    className="small d-flex align-items-center"
                                  >
                                    <BsArrowRightCircleFill className="text-primary me-2" />
                                    {app}
                                  </ListGroup.Item>
                                ))}
                              </ListGroup>
                            </Card.Body>
                          )}
                        </div>
                      </Card>
                    </Col>
                  );
                })}
              </Row>
            </Col>
            <Col md={5} className="d-none d-md-block">
              {expandedIndex !== null && (
                <Card className="shadow-lg rounded-4 p-3 h-auto">
                  <Card.Img
                    variant="top"
                    src={expertiseData[expandedIndex].image}
                    alt={expertiseData[expandedIndex].title}
                    style={{ height: "200px", objectFit: "cover" }}
                  />
                  <Card.Body>
                    <Card.Title
                      className="fw-bold text-uppercase mb-3"
                      style={{ color: "#0355f8" }}
                    >
                      {expertiseData[expandedIndex].title}
                    </Card.Title>
                    <Card.Text className="text-muted small">
                      {expertiseData[expandedIndex].description}
                    </Card.Text>

                    <h6 className="fw-bold mt-3">Features</h6>
                    <ListGroup variant="flush" className="mb-2">
                      {expertiseData[expandedIndex].features.map(
                        (feature, i) => (
                          <ListGroup.Item
                            key={i}
                            className="small d-flex align-items-center"
                          >
                            <BsCheckCircleFill className="text-success me-2" />
                            {feature}
                          </ListGroup.Item>
                        )
                      )}
                    </ListGroup>

                    <h6 className="fw-bold mt-3">Applications</h6>
                    <ListGroup variant="flush">
                      {expertiseData[expandedIndex].applications.map(
                        (app, i) => (
                          <ListGroup.Item
                            key={i}
                            className="small d-flex align-items-center"
                          >
                            <BsArrowRightCircleFill className="text-primary me-2" />
                            {app}
                          </ListGroup.Item>
                        )
                      )}
                    </ListGroup>
                  </Card.Body>
                </Card>
              )}
            </Col>
          </Row>
        </Container>
      </section> */}
    </>
  );
};

export default ExpertiseSection;
